var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c(
        "b-card",
        { attrs: { title: "Edit Loket Pendaftaran" } },
        [
          _c("b-card-text", [
            _c("form", { staticClass: "mt-5" }, [
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end col-form-label",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Loket")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("select2", {
                      attrs: {
                        id: "select-poli",
                        options: _vm.all_loket_options,
                      },
                      model: {
                        value: _vm.form.loket,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "loket", $$v)
                        },
                        expression: "form.loket",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end col-form-label",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Nama Loket Pendaftaran")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("b-form-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.form.nama,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "nama", $$v)
                        },
                        expression: "form.nama",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end col-form-label",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Prefix")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("b-form-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.form.prefix,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "prefix", $$v)
                        },
                        expression: "form.prefix",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end col-form-label",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Nomor Loket")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("b-form-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.form.nomor_loket,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "nomor_loket", $$v)
                        },
                        expression: "form.nomor_loket",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end col-form-label",
                    attrs: { for: "" },
                  },
                  [_vm._v("Penunjang & Kondisi Lain")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("b-form-checkbox", {
                      staticClass: "pt-2",
                      model: {
                        value: _vm.form.penunjang,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "penunjang", $$v)
                        },
                        expression: "form.penunjang",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end col-form-label",
                    attrs: { for: "" },
                  },
                  [_vm._v("Anteran Langsung")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("b-form-checkbox", {
                      staticClass: "pt-2",
                      model: {
                        value: _vm.form.antrean_langsung,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "antrean_langsung", $$v)
                        },
                        expression: "form.antrean_langsung",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c("div", { staticClass: "col-lg-3 text-lg-end pt-2" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-sm",
                        attrs: { variant: "primary" },
                        on: { click: _vm.updateLoketPendaftaran },
                      },
                      [_vm._v("Simpan")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-sm",
                        attrs: { variant: "danger" },
                        on: { click: _vm.cancelEdit },
                      },
                      [_vm._v("Batal")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }